import { forwardRef, createElement } from 'react';

function IconSecure(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12.01 2.25a.75.75 0 01.665.402c.72 1.376 3.174 2.323 7.389 2.683a.75.75 0 01.686.748c0 7.747-1.54 11.378-5.945 14.213l-.502.312-.525.306a26.51 26.51 0 01-.834.452l-.29.148-.323.16a.75.75 0 01-.654.003c-6.293-3-8.427-6.542-8.427-15.594a.75.75 0 01.686-.748c4.215-.36 6.67-1.307 7.389-2.683a.75.75 0 01.56-.395l.126-.007zM12 4.245l-.064.067C10.702 5.54 8.479 6.317 5.277 6.705l-.523.058.01.54c.012.53.033 1.039.063 1.525l.052.713c.472 5.577 2.312 8.141 6.618 10.372l.272.139.228.113.262-.133c4.685-2.43 6.538-5.033 6.915-11.21l.038-.743.025-.778.007-.402.001-.136-.522-.058c-3.068-.372-5.238-1.1-6.5-2.242l-.159-.15L12 4.244zM12 8l.15.005a2 2 0 01.98 3.645L14 16h-4l.87-4.35a2 2 0 01.982-3.644L11.999 8z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Secure = /*#__PURE__*/forwardRef(IconSecure);

export default Secure;
//# sourceMappingURL=Secure.js.map
